import React, { useState, useRef, useEffect, useContext } from "react";
import { Container } from "../../assets/styles/Container";
import { Header } from "../../components/Header/header";
import { RoundButton } from "../../assets/styles/RoudeButton";
import plusIcon from "../../assets/imgs/plus_icon.svg";
import { FeedStyled } from "./styles";
import { Posts } from "../../components/Posts";
import { CreatePostModal } from "./components/Modals/CreatePostModal/CreatePostModal";
import { Loading } from "../../components/LoadingProps/loading";
import {
  iPostUserImageLikeSchema,
  PostContext,
} from "../../providers/PostContext";
import { UserContext } from "../../providers/UserContext";

interface iFeed {
  setPage: React.Dispatch<React.SetStateAction<number>>;
  posts: iPostUserImageLikeSchema | null;
  loading: boolean;
}

export const FeedContent = ({ setPage, posts, loading }: iFeed) => {
  const { setPosts } = useContext(PostContext),
    { user } = useContext(UserContext)

  const [showCreatePost, setShowCreatePost] = useState(false);

  useEffect(() => {
    setPosts(null);
  }, []);

  // Sentinela
  const sentinelaRef = useRef<HTMLLIElement | null>(null); //referência ao elemento sentinela

  useEffect(() => {
    const sentinelaRefCurrent = sentinelaRef.current

    // observar o elemento sentinela
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setPage((prevPage) => prevPage + 1);
        }
      },
      {
        root: null,
        rootMargin: "0px",
        // threshold: 1.0, // garante que o elemento sentinela precisa estar totalmente visível para carregar mais posts
      }
    );

    if (sentinelaRefCurrent) {
      observer.observe(sentinelaRefCurrent);
    }

    return () => {
      if (sentinelaRefCurrent) {
        observer.unobserve(sentinelaRefCurrent);
      }
    };
  }, []);

  return (
    <>
      <Header />
      <Container>
        <FeedStyled>
          <div className="feed">
            <Posts posts={posts} />
            <li ref={sentinelaRef} id="sentinela" />
            {loading && <Loading $width="50px" />}
          </div>
          {/* <Anuncio /> */}
          {user &&
            (<abbr title="Criar novo post">
              <RoundButton id="add-post" onClick={() => setShowCreatePost(true)}>
                <img src={plusIcon} alt="plus" />
              </RoundButton>
            </abbr>)
          }
          {showCreatePost && (
            <CreatePostModal setShowCreatePost={setShowCreatePost} />
          )}
        </FeedStyled>
      </Container>
    </>
  );
};
